<!--我的评论--> 
<template>
  <div class="comment-mine-page" v-cloak>
    <van-nav-bar left-arrow fixed title="我的评论" id="nav-bar" @click-left="onClickLeft"></van-nav-bar>

    <!-- 列表 -->
    <div class="list">
      <van-list v-model="loading" :immediate-check="true" :finished="finished" finished-text="没有更多了" @load="getInit">
        <img-text-comment v-for="(item, index) in productList" :key="index" :show-type="'in'" :ind="index" :info="item" @delete="deleteComment"></img-text-comment>
      </van-list>
    </div>

    <van-empty class="custom-image" v-if="productList.length< 1" :image="noCollection" />

  </div>
</template>

<script type="text/babel">
import imgTextComment from "@/components/img-text-mine-comment/img-text-mine-comment.vue";
export default {
  name: "commentMine",
  components: { imgTextComment },
  props: {},
  data() {
    return {
      noCollection: require("../../assets/public/no-pingjia.png"),
      pageNum: 1,
      pageSize: 10,
      loading: true,
      finished: false,
      productList: [
        // {
        //   id: 1,
        //   order_sn: "1213112131",
        //   content:
        //     "拆完快递看到东西我就激动哭了，这也太好看了吧，非常好看。再也不担心耳机线了，非常方便，音质很棒。",
        //   pic: [
        //     "http://qiniu.zdyxjx.com/product/upload_pic_1608273324800",
        //     "http://qiniu.zdyxjx.com/product/upload_pic_1608273324802",
        //     "http://qiniu.zdyxjx.com/product/upload_pic_1608273324804",
        //     "http://qiniu.zdyxjx.com/product/upload_pic_1608273324806",
        //     "http://qiniu.zdyxjx.com/product/upload_pic_1608273324808",
        //   ],
        //   score: 3,
        //   created_time: "2022-12-06 19:10:28",
        //   domain: "http://www.xzbfb.com",
        // },
      ],
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.getInit();
    // this.$toast.loading();
    // setTimeout(() => {
    //   this.$toast.clear();
    // }, 300);
  },
  methods: {
    getInit() {
      let _this = this;
      this.$toast.loading();
      let data = {
        page: _this.pageNum,
        limit: _this.pageSize,
      };
      _this.$post("/api/user_comment_list", data, data).then((res) => {
        console.log(res.data);
        _this.loading = false; // 加载状态结束

        if (res.data.code == 0) {
          // console.log(res.data.data);

          let lists = res.data.data;

          if (lists && lists.length > 0) {
            lists = lists.map((item, index) => {
              return Object.assign({}, item, { checked: false });
            });

            console.log(lists);

            if (_this.pageNum == 1) {
              _this.productList = [];
              _this.productList = lists;
            } else {
              _this.productList = _this.productList.concat(lists);
            }
            _this.pageNum++;
            if (lists.length < _this.pageSize) {
              _this.finished = true; // 数据全部加载完成
            }
          } else {
            _this.finished = true; // 数据全部加载完成
          }
          _this.$toast.clear();
        } else {
          _this.$toast.fail(res.data.message);
          _this.finished = true;
        }
      });
    },
    // 删除
    deleteComment(info, ind) {
      console.log(info, ind, "删除");
      this.list.splice(ind, 1);
      this.$notify({ type: "success", message: "删除成功！" });
    },
    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss">
.comment-mine-page {
  // 空状态
  .custom-image .van-empty__image {
    width: 260px;
    height: 300px;
  }
}
</style>
<style lang="scss" scoped>
.comment-mine-page {
  // height: 100%;
  width: 100%;
  padding: 50px 0;
  background-color: #f9f9f9;
  .list {
    padding: 0 10px;
  }
}
.click:active {
  transform: scale(0.95);
  -webkit-transform: scale(0.95);
  -moz-transform: scale(0.95);
}
</style>

 